// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__3flO_","itemTitle":"ClientEmergencyInfo_itemTitle__1jpr-","itemText":"ClientEmergencyInfo_itemText__g087G"};